import * as React from 'react';
import { BaseDynamic, ComponentProps, NormalizeStateContext, CrawlContext } from '../_ho-forms-lib/src/HoForm';
import { setValidationErrorIntoState, getValidationError } from '../_ho-forms-lib/src/HoForm/utils';
import { Typography } from '@mui/material';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
    ClassicEditor,
    Essentials,
    Paragraph,
    Heading,
    Bold,
    Italic,
    Link,
    List,
    BlockQuote,
    Image,
    ImageToolbar,
    ImageCaption,
    ImageStyle,
    ImageUpload,
    MediaEmbed,
    Table,
    TableToolbar,
} from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import '../styles/ckeditor-content.css';
import './visual-editor.css';

type VisualEditorDynamicField = {
    key: string,
    type: string,
    default?: string,
    multiline?: boolean,
    tip?: string,
    title?: string,
    required?: boolean,
    monospace?: boolean,
    margin?: 'none'|'dense'|'normal'
}

type VisualEditorDynamicState = {

}

export class VisualEditorDynamic extends BaseDynamic<VisualEditorDynamicField,VisualEditorDynamicState> {

    constructor(props: ComponentProps<VisualEditorDynamicField>){
        super(props);
    }

    normalizeState({state, field}: NormalizeStateContext<VisualEditorDynamicField>){
        let key = field.key;
        if(state[key]==null){
            state[key] = field.default || '';
        }
    }

    getType(){
        return 'visual-editor';
    }

    crawlComponent({form, node} : CrawlContext<VisualEditorDynamicField>): void{
        if(node.field.required){
            const value = this.getValueFromNode(node);
            const invalid = value==null||value==='';
            setValidationErrorIntoState(node.state, form.buildDisplayPath(node), invalid?`The field is required.`:'');
        }
    }

    renderComponent(){

        let {context} = this.props;
        let {node, nodePath, currentPath, parentPath} = context;
        let {field} = node;

        if(!parentPath.startsWith(currentPath)){
            return (null);
        }

        const error = getValidationError(node.state, nodePath);

        return (<div style={{marginTop: '8px', marginBottom: '4px'}}>
            <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary' }} style={{marginBottom: '4px'}}>{field.title}</Typography>
            <CKEditor
                editor={ClassicEditor as any}
                config={{
                    plugins: [
                        Essentials,
                        Paragraph,
                        Heading,
                        Bold,
                        Italic,
                        Link,
                        List,
                        BlockQuote,
                        Image,
                        ImageToolbar,
                        ImageCaption,
                        ImageStyle,
                        ImageUpload,
                        MediaEmbed,
                        Table,
                        TableToolbar,
                    ],
                    toolbar: [
                        'heading', '|',
                        'bold', 'italic', 'link',
                        'bulletedList', 'numberedList', 'blockQuote',
                        'imageUpload', 'mediaEmbed', 'insertTable',
                        'undo', 'redo',
                    ],
                }}
                data={context.value || ''}
                onChange={(_event: any, editor: any) => {
                    const data = editor.getData();
                    this.props.context.setValue(data, 250);
                }}
            />
            { field.tip && (<Typography variant="caption" sx={{ display: 'block', color: 'text.secondary' }} style={{marginBottom: '4px'}}>{field.tip}</Typography>) }
        </div>
        );
    }
}
